<template>
  <div class="main-border">
    <v-row class="border-b ">
      <v-col cols="6" md="3" class="text-center active-color">
        <span class="text-header-step-active">Solicitudes</span>
      </v-col>
      <!-- TO BE IMPLEMENTED -->
      <!-- <v-col cols="6" md="3" class="text-center inactive-color">
        <span class="text-header-step-no-active">Clientes</span>
      </v-col>
      <v-col cols="6" md="3" class="text-center inactive-color">
        <span class="text-header-step-no-active">Emisiones</span>
      </v-col> -->
    </v-row>

    <div>
      <div>
        <IndexSolicitudes />
      </div>
    </div>
  </div>
</template>

<script>
import IndexSolicitudes from "./IndexSolicitudes.vue";

export default {
  components: {
    IndexSolicitudes,
  },
};
</script>

<style>
.border-b {
  border-bottom: 2px solid #b11f1f;
}
</style>
